module.exports = __webpack_public_path__ + "img/COWBOY HAT GREEN.eff2d78.svg";